// 所有的缓存Key保存在这里
export enum CACHEOR_KEYS {
  MATERIAL_HOME_PAGE = "PAGE:MATERIALS_HOME_NEW", // 素材首页服务端渲染缓存
  CALENDARS_PAGE = "PAGE:CALENDARS_NEW", // 热点日历聚合页服务端配置缓存
  CATEGORIES_PAGE = "PAGE:CATEGORIES",
  HOME_PAGE = "PAGE:HOME_CONFIG",
  DISCOVERY_CALENDARS = "PAGE:DISCOVERY_CALENDARS", // 缓存发现页日历数据
  FOOTER_CONFIG = "COMMON:FOOTER_CONFIG", // 缓存底部栏数据
  APP_INFO = "COMMON:APP_INFO", // app 版本信息
}
